/**
 * 创建页类型选择：平铺排序。
 * 顺序：食谱类 → HomeWorkout → POST_WORKOUT_ORDER（badge/article）→ 音乐/白噪音 → 其余。
 */

const PRIORITY_HEAD = [
  'recipe(食谱)',
  'puzzle(拼图)',
  'level(关卡)',
  'recipe_v2',
]

const WORKOUT_ORDER = [
  'workout_action',
  'workout_music',
  'workout_voice',
  'workout_collection',
]

/** 新增 zip-only 类型：插入 workout_collection 之后、音乐/白噪音之前。 */
const POST_WORKOUT_ORDER = [
  'badge',
  'article',
]

const SOUNDS_ORDER = [
  '音乐',
  'sounds(白噪音)',
  'music(白噪音)',
  'sleep story(白噪音)',
  'meditation(白噪音)',
  'ASMR(白噪音)',
  'sounds_live(白噪音)',
]

function resolveFlatSortKey(assetType) {
  const type = String(assetType || '').trim()
  const headIdx = PRIORITY_HEAD.indexOf(type)
  if (headIdx >= 0) {
    return headIdx
  }
  const workoutIdx = WORKOUT_ORDER.indexOf(type)
  if (workoutIdx >= 0) {
    return PRIORITY_HEAD.length + workoutIdx
  }
  const postWorkoutIdx = POST_WORKOUT_ORDER.indexOf(type)
  if (postWorkoutIdx >= 0) {
    return PRIORITY_HEAD.length + WORKOUT_ORDER.length + postWorkoutIdx
  }
  const soundsIdx = SOUNDS_ORDER.indexOf(type)
  if (soundsIdx >= 0) {
    return PRIORITY_HEAD.length + WORKOUT_ORDER.length + POST_WORKOUT_ORDER.length + soundsIdx
  }
  if (type.includes('白噪音') || type === '音乐') {
    return PRIORITY_HEAD.length + WORKOUT_ORDER.length + POST_WORKOUT_ORDER.length + SOUNDS_ORDER.length
  }
  return PRIORITY_HEAD.length + WORKOUT_ORDER.length + POST_WORKOUT_ORDER.length + SOUNDS_ORDER.length + 100 + type.charCodeAt(0)
}

/** 全量平铺，按业务优先级排序 */
export function flatTypeOptions(typeOptions) {
  return (typeOptions || [])
    .map((assetType) => String(assetType || '').trim())
    .filter(Boolean)
    .map((assetType) => ({ assetType }))
    .sort((a, b) => {
      const diff = resolveFlatSortKey(a.assetType) - resolveFlatSortKey(b.assetType)
      if (diff !== 0) return diff
      return a.assetType.localeCompare(b.assetType, 'en')
    })
}
